/**
 * Send message to student via AJAX
 * @param {string} journeyId
 * @param {string} message
 * @returns {Promise<Object>} Response data
 */
async function sendCoachMessage(journeyId, message) {
	const formData = new FormData();
	formData.append('action', 'coach_send_message');
	formData.append('nonce', wpcore.nonce);
	formData.append('journey_id', journeyId);
	formData.append('message', message);

	const response = await fetch(wpcore.ajaxUrl, {
		method: 'POST',
		body: formData
	});

	return await response.json();
}

export const initSendMessage = () => {
	document.addEventListener('click', async (e) => {
		const sendBtn = e.target.closest('#btn-send-message');
		if (!sendBtn) return;

		e.preventDefault();

		const popupContent = sendBtn.closest('[data-journey-id]');
		const journeyId = popupContent ? popupContent.dataset.journeyId : '';
		const textarea = document.getElementById('coach-message-text');
		const message = textarea ? textarea.value.trim() : '';

		if (!journeyId) {
			console.error('Journey ID not found');
			window.wpcore?.showAlert?.('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'System Error: Journey ID not found. Please reload the page.', fr: 'Erreur syst\u00e8me : Identifiant du parcours introuvable. Veuillez recharger la page.' }));
			return;
		}

		if (!message) {
			window.wpcore?.showAlert?.('warning', wpcore.direct_t({ en: 'Notice', fr: 'Avis' }), wpcore.direct_t({ en: 'Please enter a message', fr: 'Veuillez entrer un message' }));
			return;
		}

		// Disable button to prevent double submit
		const originalText = sendBtn.innerText;
		sendBtn.disabled = true;
		sendBtn.innerText = wpcore.direct_t({ en: 'Sending...', fr: 'Envoi en cours...' });

		try {
			const data = await sendCoachMessage(journeyId, message);

			if (data.success) {
				// Close popup
				if (typeof wpcore.closePopup === 'function') {
					wpcore.closePopup('send-message');
				} else {
					document.getElementById('popup-send-message')?.classList.add('hidden');
				}

				// Show success
				window.wpcore?.showAlert?.('success', wpcore.direct_t({ en: 'Success', fr: 'Succ\u00e8s' }), wpcore.direct_t({ en: 'Message sent successfully!', fr: 'Message envoy\u00e9 avec succ\u00e8s !' }));

				// Clear textarea
				if (textarea) textarea.value = '';
			} else {
				window.wpcore?.showAlert?.('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), data.data.message || wpcore.direct_t({ en: 'Failed to send message', fr: '\u00c9chec de l\'envoi du message' }));
			}
		} catch (error) {
			console.error('Error sending message:', error);
			window.wpcore?.showAlert?.('error', wpcore.direct_t({ en: 'Error', fr: 'Erreur' }), wpcore.direct_t({ en: 'An error occurred. Please try again.', fr: 'Une erreur est survenue. Veuillez r\u00e9essayer.' }));
		} finally {
			sendBtn.disabled = false;
			sendBtn.innerText = originalText;
		}
	});
};
